'use client';
export { default } from './CompanyLogosSlider';